import {ReactionViewerLoading} from '@github-ui/reaction-viewer/ReactionViewerLoading'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Box} from '@primer/react'
import {useMemo} from 'react'

export const CommentLoading = () => {
  const lineCount = useMemo(() => Math.floor(Math.random() * 3) + 1, [])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}
    >
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'neutral.muted',
          borderRadius: 6,
          backgroundColor: 'canvas.default',
          boxShadow: 'shadow.small',
          overflowX: 'auto',
          flexGrow: 1,
        }}
      >
        <Box sx={{display: 'flex', gap: 2, m: 3, flexDirection: 'column'}}>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <LoadingSkeleton variant="elliptical" height="xl" width="xl" />
            <LoadingSkeleton variant="rounded" height="sm" width="150px" />
          </Box>

          {[...Array(lineCount)].map((_, index) => (
            <LoadingSkeleton key={index} variant="rounded" height="sm" width="random" />
          ))}
          <ReactionViewerLoading />
        </Box>
      </Box>
    </Box>
  )
}

try{ CommentLoading.displayName ||= 'CommentLoading' } catch {}